import { selectFeatureFlags } from 'core/userContext';
import { useSelector } from 'react-redux';
import { RumComponentContextProvider } from 'services/observability/datadog';
import { Product, Team } from 'teams';
import { BaseMenu } from './BaseMenu';

export const QuickActionsMenu = () => {
  const { QuickActionsMenu: QuickActionsMenuFeatureFlag } = useSelector(selectFeatureFlags);

  if (!QuickActionsMenuFeatureFlag) return null;

  return (
    <RumComponentContextProvider
      componentName="QuickActionsMenu"
      teamName={Team.PLATFORM_TEAM}
      productName={Product.QUICK_ACTIONS}
    >
      <BaseMenu />
    </RumComponentContextProvider>
  );
};
